export const environment = {
  stage: 'uat',
  production: true,
  apiBase: 'https://api.uat.vbmc.travelex.cloud/api/v1/client'
};
